// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drag-drop {
    border: 1px solid var(--border-color);
    border-radius: 8px;
  }
  .document-uploader {
    border: 2px dashed #4282fe;
    background-color: #f4fbff;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    border-radius: 8px;
    cursor: pointer;
  
    &.active {
      border-color: #6dc24b;
    }
  
    .upload-info {
      display: flex;
      align-items: center;
      margin-bottom: 1rem;
  
      svg {
        font-size: 36px;
        margin-right: 1rem;
      }
  
      div {
        p {
          margin: 0;
          font-size: 16px;
        }
  
        p:first-child {
          font-weight: bold;
        }
      }
    }
  
    .file-list {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      width: 100%;
      /* height: 30vh; */
      &__container {
        width: 100%;
        height: 100%;
        overflow: auto;
      }
    }
  
    .file-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.5rem;
      border: 1px solid var(--border-color);
      border-radius: 8px;
  
      .file-info {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        flex: 1 1;
  
        p {
          margin: 0;
          font-size: 14px;
          color: #333;
        }
      }
  
      .file-actions {
        cursor: pointer;
  
        svg {
          font-size: 18px;
          color: #888;
        }
  
        &:hover {
          svg {
            color: #d44;
          }
        }
      }
    }
  
    .browse-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.5rem 1rem;
      border: 1px solid var(--border-color);
      border-radius: 8px;
      cursor: pointer;
      background-color: var(--primary-color);
      &:hover {
        background-color: transparent;
      }
    }
  
    .success-file {
      display: flex;
      align-items: center;
      color: #6dc24b;
  
      p {
        margin: 0;
        font-size: 14px;
        font-weight: bold;
      }
    }
  
    input[type="file"] {
      display: none;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/common/drag-drop.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;;IAEf;MACE,qBAAqB;IACvB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,mBAAmB;;MAEnB;QACE,eAAe;QACf,kBAAkB;MACpB;;MAEA;QACE;UACE,SAAS;UACT,eAAe;QACjB;;QAEA;UACE,iBAAiB;QACnB;MACF;IACF;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,WAAW;MACX,WAAW;MACX,kBAAkB;MAClB;QACE,WAAW;QACX,YAAY;QACZ,cAAc;MAChB;IACF;;IAEA;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,eAAe;MACf,qCAAqC;MACrC,kBAAkB;;MAElB;QACE,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,SAAO;;QAEP;UACE,SAAS;UACT,eAAe;UACf,WAAW;QACb;MACF;;MAEA;QACE,eAAe;;QAEf;UACE,eAAe;UACf,WAAW;QACb;;QAEA;UACE;YACE,WAAW;UACb;QACF;MACF;IACF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,oBAAoB;MACpB,qCAAqC;MACrC,kBAAkB;MAClB,eAAe;MACf,sCAAsC;MACtC;QACE,6BAA6B;MAC/B;IACF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,cAAc;;MAEd;QACE,SAAS;QACT,eAAe;QACf,iBAAiB;MACnB;IACF;;IAEA;MACE,aAAa;IACf;EACF","sourcesContent":[".drag-drop {\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n  }\n  .document-uploader {\n    border: 2px dashed #4282fe;\n    background-color: #f4fbff;\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    border-radius: 8px;\n    cursor: pointer;\n  \n    &.active {\n      border-color: #6dc24b;\n    }\n  \n    .upload-info {\n      display: flex;\n      align-items: center;\n      margin-bottom: 1rem;\n  \n      svg {\n        font-size: 36px;\n        margin-right: 1rem;\n      }\n  \n      div {\n        p {\n          margin: 0;\n          font-size: 16px;\n        }\n  \n        p:first-child {\n          font-weight: bold;\n        }\n      }\n    }\n  \n    .file-list {\n      display: flex;\n      flex-direction: column;\n      gap: 0.5rem;\n      width: 100%;\n      /* height: 30vh; */\n      &__container {\n        width: 100%;\n        height: 100%;\n        overflow: auto;\n      }\n    }\n  \n    .file-item {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 0.5rem;\n      border: 1px solid var(--border-color);\n      border-radius: 8px;\n  \n      .file-info {\n        display: flex;\n        flex-direction: column;\n        gap: 0.25rem;\n        flex: 1;\n  \n        p {\n          margin: 0;\n          font-size: 14px;\n          color: #333;\n        }\n      }\n  \n      .file-actions {\n        cursor: pointer;\n  \n        svg {\n          font-size: 18px;\n          color: #888;\n        }\n  \n        &:hover {\n          svg {\n            color: #d44;\n          }\n        }\n      }\n    }\n  \n    .browse-btn {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 0.5rem 1rem;\n      border: 1px solid var(--border-color);\n      border-radius: 8px;\n      cursor: pointer;\n      background-color: var(--primary-color);\n      &:hover {\n        background-color: transparent;\n      }\n    }\n  \n    .success-file {\n      display: flex;\n      align-items: center;\n      color: #6dc24b;\n  \n      p {\n        margin: 0;\n        font-size: 14px;\n        font-weight: bold;\n      }\n    }\n  \n    input[type=\"file\"] {\n      display: none;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
